export default function AgencyPrinciple() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="font-sora font-bold text-5xl text-charcoal mb-6">
            Built on One Core Principle
          </h2>
          <p className="font-inter text-2xl text-gray-800 leading-relaxed max-w-3xl mx-auto">
            Your website should look premium — and perform.
          </p>
        </div>

        <div className="space-y-8 font-inter text-lg text-gray-700 leading-relaxed">
          <p>
            In today's market, your online presence is often the first impression customers have of your business. It shapes credibility, influences trust, and directly impacts whether someone chooses you or your competitor. At LaCrue Digital Agency, we build clean, modern, mobile-first websites designed to convert visitors into customers — not just exist online.
          </p>

          <div className="bg-white rounded-2xl p-10 shadow-md">
            <h3 className="font-sora font-bold text-2xl text-charcoal mb-6">
              We focus on simplicity and structure:
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <span className="text-blue-600 mr-3 mt-1">•</span>
                <span>Clean, professional design</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-3 mt-1">•</span>
                <span>Clear messaging</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-3 mt-1">•</span>
                <span>Mobile-first performance</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-3 mt-1">•</span>
                <span>SEO-ready foundation</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-3 mt-1">•</span>
                <span>Fast, efficient turnaround</span>
              </li>
            </ul>
          </div>

          <p className="text-center text-xl font-medium text-charcoal pt-6">
            No clutter. No unnecessary complexity. Just digital assets built correctly from day one.
          </p>
        </div>
      </div>
    </section>
  );
}